// tienda/BeneficiosSection.jsx

import React from "react";
import { motion } from "framer-motion";
import { Clock, HandCoins, MapPin, MessageSquare, PhoneCall, Truck } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const ITEMS = [
  { icon: <MapPin className="size-5" />, title: "Seguimiento en vivo", text: "Tu equipo y tus clientes ven el avance de cada pedido sin preguntar por WhatsApp." },
  { icon: <MessageSquare className="size-5" />, title: "Mensajes automáticos", text: "Actualizaciones en cada hito: recojo, ruta, llegada y entrega confirmada." },
  { icon: <HandCoins className="size-5" />, title: "Pago contraentrega", text: "Cobramos por ti, conciliamos lo recaudado y mantenemos visible cada monto." },
  { icon: <Clock className="size-5" />, title: "Mismo día", text: "Pedidos ingresados a tiempo salen a reparto y llegan antes de las 8:00 PM." },
  { icon: <Truck className="size-5" />, title: "Tarifa clara", text: "Precios simples por entrega para que puedas vender con margen desde el inicio." },
  { icon: <PhoneCall className="size-5" />, title: "Soporte humano", text: "Acompañamiento real cuando una dirección cambia, un cliente demora o un pedido urge." },
];

export function BeneficiosSection() {
  return (
    <section id="beneficios" className="border-b bg-white scroll-mt-16" style={{ borderColor: brand.line }}>
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-14 md:grid-cols-[0.8fr_1.2fr] md:py-20">
        <motion.div {...fadeUp}>
          <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
            Operación visible
          </p>
          <h2 className="text-3xl font-black leading-tight md:text-4xl" style={{ color: brand.ink }}>
            Menos coordinación manual. Más pedidos entregados.
          </h2>
          <p className="mt-4 text-sm leading-relaxed md:text-base" style={{ color: brand.muted }}>
            Fast Max reúne la parte difícil de vender online en Lima: coordinar recojos,
            responder estados, cobrar contraentrega y confirmar entregas sin perder control.
          </p>
        </motion.div>

        <div className="grid gap-3 sm:grid-cols-2">
          {ITEMS.map((item, index) => (
            <motion.div
              key={item.title}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: index * 0.04 }}
              className="rounded-2xl border bg-white p-5 shadow-sm"
              style={{ borderColor: brand.line }}
            >
              <div className="mb-4 grid size-11 place-items-center rounded-xl" style={{ background: `${brand.primary}12`, color: brand.primary }}>
                {item.icon}
              </div>
              <h3 className="text-sm font-black" style={{ color: brand.ink }}>{item.title}</h3>
              <p className="mt-2 text-xs leading-relaxed" style={{ color: brand.muted }}>{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
